import * as types from "../types";
import { simplifyJson } from "../../shared/utility";
import EncrDecrService from "../../services/EncrDecrService.Service";
import {
  setAppContent,
  // setCardListContent,
  // setErrorCodeVerbiage,
  // setOccupationContent,
} from "../../shared/AppContent";
// eslint-disable-next-line no-unused-vars
export const fetchAppContent = () => async (dispatch) => {
    const isLocalhost = Boolean(
      window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.0/8 are considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    );
    const content_url = isLocalhost ? process.env.PUBLIC_URL+`/GetContentEnc.txt` :  window.global.config?.GetContentEnc;
    var response;
    await fetch(content_url)
    .then((r) => r.text())
    .then(text  => {
      response = JSON.parse(EncrDecrService.get(text));
    });    
  if (response && response.data) {
     if (response.statusCode === "000") {
      //const content = response?.data?.root?.content;

      const content = response?.data?.root?.content;
      if (content && setAppContent(content)) {
        simplifyJson(content);
        
        dispatch({
          type: types.SET_APP_CONTENT,
          payload: content,
        });
      }

      const cardListContent = response?.data?.root?.cardData?.card;
      const bannerContent = response?.data?.root?.content?.happy_to_help_banners;
      if (cardListContent) {
        simplifyJson(cardListContent);
        dispatch({
          type: types.SET_CND_CONTENT,
          payload: { cardList: cardListContent, bannerContent: bannerContent ? bannerContent : null },
        });
      }
    } 
  } 
  return response?.statusCode;
};
